import { Component, Inject } from '@angular/core';
import { EnvironmentVariablesService } from '@kenv';
import { DataStoreService, WINDOW, productDisplayName } from '@kservice';
import { Product } from '@ktypes/enums';

@Component({
  selector: 'kp-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent {
  getEncodedURI = encodeURI;
  environment = this._environmentVariablesService.config;
  showVote = this._environmentVariablesService.product === Product.purposeful;
  productName = productDisplayName;

  constructor(
    public dataStoreService: DataStoreService,
    private _environmentVariablesService: EnvironmentVariablesService,
    @Inject(WINDOW) public window: Window
  ) {}
}
